/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-09-16 13:05:47
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-11-05 17:20:02
 * @FilePath: /unifyxp-v2-store-portal/src/tools/message.ts
 */
/**
 * Toast with icon for Warning, Error, and Success scenarios.
 * Read this link for detail - https://ant.design/components/message/
 */

import { message } from 'antd';

export const msg = {
  warning: (content, duration = 3) => {
    message.config({
      top: 195,
    });
    return message.warning(content, duration);
  },
  loading: (content, duration = 3) => {
    message.config({
      top: 195,
    });
    return message.loading(content, duration);
  },

  error: (content, duration = 3) => {
    message.config({
      top: 195,
    });
    return message.error(content, duration);
  },

  success: (content, duration = 3, ...rest) => {
    message.config({
      top: 195,
    });
    return message.success(content, duration);
  },
  destroy: () => {
    message.destroy();
  },
};
